import { Redirect } from 'react-router-dom';

import { ROUTES_URL } from 'src/constants/routes';

export default function LeadsmaniaBillingRedirect() {
    return <Redirect to={ROUTES_URL.LEADSTREAM} />;
}
